import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-10 text-black" }
const _hoisted_2 = { class: "flex justify-between flex-wrap items-center col-span-12" }
const _hoisted_3 = { class: "container mx-auto flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = {
  key: 0,
  class: "container mx-auto mt-2"
}
const _hoisted_6 = { class: "text-h-error-400 text-sm" }
const _hoisted_7 = { class: "container mx-auto mt-8" }
const _hoisted_8 = { class: "grid grid-cols-12 items-center overflow-auto px-5 py-3 gap-5" }
const _hoisted_9 = { class: "col-span-12 text-[18px] font-[700]" }
const _hoisted_10 = { class: "flex gap-2 flex-col p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ListObjective = _resolveComponent("ListObjective")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_ObjectiveList = _resolveComponent("ObjectiveList")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("objectives.titles.objectives")), 1),
          _createVNode(_component_Button, {
            id: "objective-add-btn",
            label: _ctx.$t('labels.add', { pt: 'objetivo', en: 'objective' }),
            class: "btn-outline p-button-sm",
            icon: "pi pi-plus",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToObjective()))
          }, null, 8, ["label"])
        ]),
        _createVNode(_component_Button, {
          id: "objective-next-btn",
          label: _ctx.$t('labels.generic', { pt: 'Continuar', en: 'Continue' }),
          class: "btn-primary p-button-sm",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveObjectives()))
        }, null, 8, ["label"])
      ]),
      (_ctx.textError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.textError), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_7, [
        _createVNode(_component_InfiniteScroll, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Lista de objetivos",
                    en: "List of objectives",
                  })), 1)
            ])
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectives, (objective, j) => {
                return (_openBlock(), _createBlock(_component_ListObjective, {
                  key: j,
                  objective: objective,
                  chapter: _ctx.chapter,
                  courseId: _ctx.params.courseId,
                  onOnOrder: _ctx.openMaterialsDialog,
                  hasOrder: ""
                }, null, 8, ["objective", "chapter", "courseId", "onOnOrder"]))
              }), 128)),
              (_ctx.objectives.length === 0)
                ? (_openBlock(), _createBlock(_component_EmptyData, {
                    key: 0,
                    data: true,
                    title: `${_ctx.$t('labels.generic', {
                  pt: 'Nenhum objetivo adicionado',
                  en: 'No objectives added',
                })}`,
                    label: `${_ctx.$t('labels.generic', {
                  pt: 'Os objetivos ficarão listados aqui. Clique em “Adicionar objetivos” para ver esses itens.',
                  en: 'The objectives will be listed here. Click “Add objectives” to view these items.',
                })}`,
                    image: 'empty-objectives.svg',
                    imgSize: "h-40",
                    class: "mt-16"
                  }, null, 8, ["title", "label", "image"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.dialogOrder,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogOrder) = $event)),
      draggable: false,
      breakpoints: { '960px': '95vw', '640px': '95vw' },
      style: { width: '40vw', minWidth: '360px' },
      modal: true,
      header: _ctx.$t('order.header', { name: _ctx.currentObjective.name }),
      onHide: _ctx.onCloseOrder
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ObjectiveList, {
          data: _ctx.currentMaterials,
          "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentMaterials) = $event)),
          loader: _ctx.loading,
          "onUpdate:loader": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loading) = $event)),
          "lesson-id": _ctx.currentObjective.lessonPlan,
          onOnEdit: _ctx.goToEditObject,
          onOnDelete: _ctx.deleteObject
        }, null, 8, ["data", "loader", "lesson-id", "onOnEdit", "onOnDelete"])
      ]),
      _: 1
    }, 8, ["visible", "header", "onHide"])
  ]))
}